import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  ElementRef,
  ViewChild,
  inject,
} from '@angular/core';
import {NgClass} from '@angular/common';

@Component({
  selector: 'app-topnav',
  templateUrl: './topnav.component.html',
  styleUrl: './topnav.component.scss',
  exportAs: 'topnav',
  standalone: true,
  imports: [NgClass],
})
export class TopnavComponent implements AfterViewChecked {
  private cdr = inject(ChangeDetectorRef);

  @ViewChild('topnavIcon') private topnavIcon: ElementRef<HTMLElement>;

  private topnavIconLength: number;

  topnavIconPresent: boolean;

  constructor() {
    this.topnavIconLength = 0;
    this.topnavIconPresent = false;
  }

  ngAfterViewChecked() {
    const elemChildrenLength = this.topnavIcon.nativeElement.children.length;

    if (this.topnavIconLength === elemChildrenLength) {
      return;
    }

    this.topnavIconLength = elemChildrenLength;

    if (this.topnavIconLength > 0) {
      this.topnavIconPresent = true;
    } else {
      this.topnavIconPresent = false;
    }

    this.cdr.detectChanges();
  }
}
